import { Button } from '@/components';
import * as React from 'react';
import { useState, useContext } from 'react';
import { Auth } from 'aws-amplify';
import { useStyles } from './styles';
import * as classNames from 'classnames';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { VideoContext } from '@/GlobalProvider/VideoProvider';
import { signOut } from '@/api/sign-out';
import { UserRoles } from '@/constants';
import { useAppData } from '@/zustand/useAppData';
import { useAssetsData } from '@/zustand/useAssetsData';
import { useAttendantData } from '@/zustand/useAttendantData';
import { trackPageView } from '@/gtag/utils';

export const Menu = () => {
  const removeAppData = useAppData((store) => store.removeAppData);
  const {
    assetsData: {
      asset_list: { faq_url, support_url },
      behavior_list: { prescan_video_display, attendant_flow }
    },
    removeAssetsData
  } = useAssetsData((store) => store) || {};
  const { user, removeAttendantData } = useAttendantData((store) => store);

  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const styles = useStyles();
  const { setShowVideo } = useContext(VideoContext);
  const [userEmail, setUserEmail] = useState(null);

  const navigate = useNavigate();

  const showVideo = () => {
    setShowVideo(true);
    setIsMenuVisible(false);
  };

  const getUserEmail = useCallback(async () => {
    const user = await Auth.currentUserInfo();
    const email = user?.attributes?.email;

    setUserEmail(email);
  }, []);

  const signOutHandler = async () => {
    removeAppData();
    removeAssetsData();
    removeAttendantData();
    await signOut();
    navigate('/');
  };

  useEffect(() => {
    getUserEmail();
  }, []);

  return (
    <div
      className={classNames(styles.menu, {
        [styles.openMenu]: isMenuVisible
      })}
    >
      <div
        className={`${classNames(styles.burger, {
          [styles.openBurger]: isMenuVisible
        })} pw-indent-burger`}
        onClick={() => setIsMenuVisible(!isMenuVisible)}
      >
        <span />
      </div>
      {isMenuVisible && (
        <ul>
          {!!userEmail && (
            <li>
              <Button
                onClick={() => {
                  trackPageView('/about', 'About');
                  navigate('/about');
                }}
                className={styles.button}
                text="About"
                size="large"
              />
            </li>
          )}
          <li>
            <Button
              onClick={() => {
                trackPageView('/internetConnection', 'Internet Connection');
                navigate('/internetConnection');
              }}
              className={styles.button}
              text="Internet connection"
              size="large"
            />
          </li>
          {faq_url && (
            <li>
              <Button
                onClick={() => {
                  trackPageView(faq_url, 'Resources');
                  window.open(faq_url);
                }}
                className={styles.button}
                text="Resources"
                size="large"
              />
            </li>
          )}
          {support_url && (
            <li>
              <Button
                onClick={() => {
                  trackPageView(support_url, 'Support');
                  window.open(support_url);
                }}
                className={styles.button}
                text="Support"
                size="large"
              />
            </li>
          )}
          {(prescan_video_display === 'hamburger_menu_only' ||
            prescan_video_display === 'both_locations') && (
            <li>
              <Button
                onClick={() => {
                  trackPageView('/', 'Instruction video');
                  showVideo();
                }}
                className={styles.button}
                text="Instruction video"
                size="large"
              />
            </li>
          )}
          {attendant_flow === 'true' && user?.role === UserRoles.Admin && (
            <li>
              <Button
                onClick={() => {
                  trackPageView('/attendantManagement', 'Attendants');
                  navigate('/attendantManagement');
                }}
                className={styles.button}
                text="Attendants"
                size="large"
              />
            </li>
          )}
          <li>
            <Button
              onClick={() => {
                trackPageView('/', 'Log out');
                signOutHandler();
              }}
              className={styles.button}
              text="Log out"
              size="large"
            />
          </li>
        </ul>
      )}
    </div>
  );
};
